import { SxProps, Theme } from '@mui/material';
import Box from '@mui/material/Box';

import { OverflowAwareText } from '~components/Order/ordersDispatchStyledComponents';
import { Ticket } from '~hooks/useTickets/models';
import { dateFormat } from '~utils/dateTime';

interface DatetimeColumnProps {
  sx?: SxProps<Theme>;
  ticket?: Ticket;
}

export default function DatetimeColumn({ sx, ticket }: DatetimeColumnProps) {
  const ticketDate = ticket?.serviceDate || ticket?.ocrServiceDate || ticket?.createdAt;
  const timeString = ticketDate ? dateFormat(new Date(ticketDate), 'h:mm A') : '-';
  const dateString = ticketDate ? dateFormat(new Date(ticketDate), 'MMM D, YYYY') : '-';

  return (
    <Box sx={sx}>
      <OverflowAwareText sx={{ fontWeight: 600 }}>{timeString}</OverflowAwareText>
      <OverflowAwareText sx={(theme) => ({ color: theme.brandV2.colors.treadGray2 })}>
        {dateString}
      </OverflowAwareText>
    </Box>
  );
}
